import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { FaLink } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PROTOCOL_DATA_PROVIDER_ADDRESSES } from '../constants';
export var GetReserveTokensAddresses = createPlugin({
    protocol: 'AAVE',
    type: 'GETTER',
    method: 'getReserveTokensAddresses',
    supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_protocol_data_provider_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaLink }),
                },
            },
            output: {
                aTokenAddress: new FctAddress({ innerIndex: 0 }),
                stableDebtTokenAddress: new FctAddress({ innerIndex: 1 }),
                variableDebtTokenAddress: new FctAddress({ innerIndex: 2 }),
            },
        });
    },
});
